import * as actions from './actions'

export const INITIAL_STATE = {
  price: null,
  urlImage: null,
  brandsList: null,
  brand: null,
  modelsGroupList: null,
  modelGroup: null,
  modelsList: null,
  model: null,
  finishesList: null,
  finishes: null,
  motorsList: null,
  motor: null,
  designList: {
    exterior: {
      type: [],
      color: []
    },
    interior: { leathers: [], fabrics: [] }
  },
  design: {
    exterior: {
      type: null,
      color: null
    },
    interior: null
  },
  optionsList: { equipmentGroups: [], equipments: [] },
  options: null,
  serviceContractsList: null,
  serviceContracts: null,
  fundingList: null,
  funding: null
}

export default function configuratorReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.SET_CONFIGURATOR: {
      return action.configurator
    }
    case actions.RESET_CONFIGURATOR: {
      return INITIAL_STATE
    }
    default:
      return state
  }
}
